import { useState, useEffect } from 'react';
import api from '../services/api';

let cachedConfig = null;
let fetchPromise = null;

const useClientConfig = () => {
  const [config, setConfig] = useState(cachedConfig);

  useEffect(() => {
    // If already cached with actual data, use it
    if (cachedConfig && Object.keys(cachedConfig).length > 0) {
      setConfig(cachedConfig);
      return;
    }

    // Avoid duplicate fetches
    if (fetchPromise) {
      fetchPromise.then(c => setConfig(c));
      return;
    }

    fetchPromise = api.get('/client-config')
      .then(res => {
        cachedConfig = res.data;
        setConfig(res.data);
        fetchPromise = null;
        return res.data;
      })
      .catch((err) => {
        fetchPromise = null;
        setConfig({});
        return {};
      });
  }, []);

  return config || {};
};

// Allow invalidating cache (e.g., after login)
export const invalidateClientConfig = () => {
  cachedConfig = null;
  fetchPromise = null;
};

export default useClientConfig;
